





















import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../../domain";
import { Document } from "../../../../../domain/document";
import { IContentSource } from "../../../../../domain/drawing";
import { ModelEditableMixin } from "../../../../system/mixins";
import { CommonComponentsAccessibleMixin } from "../../../../document/editor/mixins";

@Component
export default class TestsDebugger extends Mixins(
  ModelEditableMixin,
  CommonComponentsAccessibleMixin,
) {
  validate(): void {
    this.commonComponents.operators.validator.validate(false)
    .then(result => {
      const count = this.editingSource.alerts.length;
      if (result.isOk) {
        this.$success("確認結果", "登録可能です。(警告件数:" + count + ")");
      } else {
        this.$warn("確認結果", "登録できません。(警告件数:" + count + ")");
      }
    })
    .catch(e => {
      this.$warn("警告", "警告処理中にエラーが発生しました。", e);
    });
  }

  showPrintPdf(): void {
    this.showPdf(
      d => {
        const repository = DomainRegistry.document.getDocumentRepository();
        return repository.createPrintSource(d, false);
      }
    );
  }

  private showPdf(create: (d: Document) => Promise<IContentSource>): void {
    this.commonComponents.dialogs.printer.preview.showForDebug(create, this.editingSource.source, this.editingSource.currentSectionIndex + 1)
    .catch(e => {
      this.$error(
        "印刷用PDF表示エラー",
        "印刷用PDFを表示できませんでした。",
        e
      );
    });
  }

  showOriginalPdf(): void {
    this.showPdf(
      d => {
        const repository = DomainRegistry.document.getDocumentRepository();
        return repository.createOriginalSource(d);
      }
    );
  }
}
